function getBlogListThumb(imageSrc) {
    if (null == imageSrc) {
        return;
    }
    return imageSrc.replace('image', 'thumb_list_image');
}

function getBlogDetailImage(imageSrc) {
    if (null == imageSrc) {
        return;
    }
    return imageSrc.replace('image', 'thumb_detail_image');
}

function getBlogOgImage(imageSrc) {
    if (null == imageSrc) {
        return;
    }
    return imageSrc.replace('og_image', 'thumb_og_image');
}

export { getBlogListThumb, getBlogDetailImage, getBlogOgImage };
